import UpcomingLiveCard from "../UpcomingLiveCard/UpcomingLiveCard";
import React, { useEffect, useState } from "react";
import {
  getLiveCardDeepLink,
  getLiveCardIsAgora,
  getNewLiveCardStackType,
  LIVE_STACKTYPES,
} from "../../utils/liveService/util";
import { getUpcomingClassesService } from "../../utils/services";
import "../UpcomingLiveCard/UpcomingLiveCard.scss"
import { Image } from "../Image";
import { getAwsAssets } from "../../utils";
import Navbar from "../Navbar";
const UPLCOMING_CLASSES_LIMIT = 50
const UpcomingClasses = ({ className }) => {
  // LIMIT
  let limit = 10;
  const [offset, setOffSet] = useState(0)
  const [upcomingClasses, setUpcomingClasses] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [hasMoreData, setHasMoreData] = useState(true)

  const fetchUpcomingClasses = async () => {
    try {
        const liveClasses = await getUpcomingClassesService(limit, offset, 0)
        if(liveClasses?.data?.data?.list && liveClasses?.data?.data?.list.length){
          setOffSet(offset + liveClasses?.data?.data?.list.length)
          setUpcomingClasses([...upcomingClasses, ...liveClasses?.data?.data?.list])
          setTotalCount(liveClasses?.data?.data?.totalCount)
        }else {
          setHasMoreData(false)
        }
    } catch (error) {
      console.log("something went wrong", error?.message)
    }finally{
      setLoading(false)
    }
  };

  const fetchMore = () => {
    fetchUpcomingClasses(offset + limit);
  };


  const useNewLiveService = 1;

  // INFINITESCROLL
  const observer = React.useRef();

  const lastRowRef = React.useCallback(
    (element) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreData && upcomingClasses.length < UPLCOMING_CLASSES_LIMIT) { //&& offset + limit < totalCount 
          fetchMore();
        }
      });
      if (element) observer.current.observe(element);
    },
    [offset < totalCount, fetchMore]
  );

  useEffect(() => {
    fetchUpcomingClasses();
  }, []);


  return (
  <>

      <Navbar heading={"Upcoming Live Classes"}/>
      <div className="UpcomingLiveModal">
        {loading ? 
        null
        :
        upcomingClasses.length ? upcomingClasses?.map((item, i) => {
          return (
            <div
              key={i || item?.id || i}
              className="UpcomingLiveModal__ListItem"
              {...(i === upcomingClasses?.length - 1 && fetchMore
                ? { ref: lastRowRef }
                : {})}
            >
              <UpcomingLiveCard
                upcomingClass={{...item, scheduleTime: item.scheduleTime * 1000 }}
                index={i}
                deeplink={getLiveCardDeepLink(item?.liveCard)}
                isAgora={
                  true
                }
                emblem4={item?.emblem4}
              />
            </div>
          );
        })
      :
      <p className="no-live-classes">
        No Upcoming Live Classes!
      </p>
      }
      </div>
      </>
  );
};

export default UpcomingClasses;
